export const shortenAddress = (address: string) =>
  address.substr(0, 6) + "......" + address.substr(-4);

export const shortenAmount = (amount: string) => amount.substr(0, 6) + "....." + amount.substr(-4);
